module.exports = __webpack_public_path__ + "img/sdn.c466d90e.svg";